module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enable) ? _c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._t("icon"), _vm._v(" "), _c('span', {
    staticClass: "ml-2 fs-5 bold"
  }, [_vm._v(_vm._s(_vm.name))])], 2), _vm._v(" "), (_vm.connected) ? _c('button', {
    staticClass: "button-social-connect is-danger",
    class: _vm.loading && 'is-loading',
    on: {
      "click": _vm.disconnect
    }
  }, [_vm._v("Disconnect")]) : _c('a', {
    staticClass: "button-social-connect is-success",
    attrs: {
      "href": _vm.connectURL
    }
  }, [_vm._v("Connect")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-578894c4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialConnectItem.vue
// module id = 1041
// module chunks = 0